import { useState } from "react";
import { FileDown } from "lucide-react";
import { Periods, ProfitChart } from "../components/common";
import { api, errMsg, signedUsd } from "../lib/api";

const lastMonths = () => Array.from({ length: 12 }, (_, i) => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - i); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });

const ReportDownload = () => {
  const [month, setMonth] = useState(lastMonths()[0]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const download = async () => {
    setBusy(true);
    setError("");
    try {
      const r = await api.get("/reports/monthly", { params: { month }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `pojokchart-${month}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(errMsg(err, "Laporan gagal dibuat"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="report-box">
      <select value={month} onChange={(e) => setMonth(e.target.value)} data-testid="report-month-select">{lastMonths().map((m) => <option key={m}>{m}</option>)}</select>
      <button className="primary" disabled={busy} onClick={download} data-testid="download-report-button"><FileDown size={15} /> {busy ? "Menyiapkan…" : "Unduh laporan PDF"}</button>
      {error && <small className="down" data-testid="report-error">{error}</small>}
    </div>
  );
};

export default function Performance({ data }) {
  const [period, setPeriod] = useState("daily");
  const series = data?.series?.[period] || [];
  const total = series.length ? series[series.length - 1].cumulative : 0;
  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ANALYTICS</p><h2>Kurva perkembangan</h2><p className="muted">Profit & loss bersih (profit + komisi + swap) dari semua akun.</p></div>
        <ReportDownload />
      </div>
      <section className="panel chart-panel large">
        <div className="panel-head">
          <div><h3>Pertumbuhan kumulatif</h3><p className="muted">{data?.trades || 0} deal · win rate {data?.win_rate || 0}%</p></div>
          <Periods value={period} onChange={setPeriod} prefix="performance" />
        </div>
        <div className={total >= 0 ? "big-number" : "big-number neg"} data-testid="performance-total">{signedUsd(total)}</div>
        <ProfitChart data={series} tall color={total >= 0 ? "#3b82f6" : "#f16d6d"} />
      </section>
      <section className="panel table-panel mt">
        <div className="panel-head"><h3>Rincian per periode</h3></div>
        <div className="table-row cols-3 table-head"><span>PERIODE</span><span>P/L</span><span>KUMULATIF</span></div>
        {[...series].reverse().map((r) => (
          <div className="table-row cols-3" key={r.name} data-testid={`performance-row-${r.name}`}>
            <span>{r.name}</span><span className={r.profit >= 0 ? "up" : "down"}>{signedUsd(r.profit)}</span><span>{signedUsd(r.cumulative)}</span>
          </div>
        ))}
      </section>
    </>
  );
}
